import { Navigate, RouteObject } from 'react-router-dom';
import {
    MenuMesChantiersPage,
    ApprovisionnementPage,
    CategoryProductsPage,
    CartPage,
    MyOrdersPage,
    OrderCartPage,
    FavoriteOrdersPage,
    MyWorksiteResultsPage,
    WorksiteResultsPage,
    EventFeedbackPage,
    QuitusPage,
    NewQuitusPage,
    TestsheetsPage,
    CreateTestsheetsPage,
    BibliothequePage
} from '@pages';

export const mesChantiersRoutes = (isLogged: boolean | null | undefined): RouteObject[] => [
    {
        path: '/mes-chantiers',
        element: isLogged ? <MenuMesChantiersPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/approvisionnement',
        element: isLogged ? <ApprovisionnementPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/approvisionnement/category/:id',
        element: isLogged ? <CategoryProductsPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/approvisionnement/cart',
        element: isLogged ? <CartPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/approvisionnement/cart/:id',
        element: isLogged ? <OrderCartPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/approvisionnement/orders',
        element: isLogged ? <MyOrdersPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/approvisionnement/orders/favorites',
        element: isLogged ? <FavoriteOrdersPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/bibliotheque',
        element: isLogged ? <BibliothequePage type="chantier" /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/event-feedback',
        element: isLogged ? <EventFeedbackPage eventDestination="chantier" /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/my-worksite-results',
        element: isLogged ? <MyWorksiteResultsPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/worksite-results',
        element: isLogged ? <WorksiteResultsPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/quitus',
        element: isLogged ? <QuitusPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/quitus/new',
        element: isLogged ? <NewQuitusPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/testsheets',
        element: isLogged ? <TestsheetsPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/mes-chantiers/testsheets/create/:testsheetId',
        element: isLogged ? <CreateTestsheetsPage /> : <Navigate to="/login" replace />
    }
];

// Backup routes
// {
//     path: '/mes-chantiers/event-feedback-problem/pieuvre',
//     element: isLogged ? <PieuvreFormPage /> : <Navigate to="/login" replace />
// },
// {
//     path: '/mes-chantiers/event-feedback-problem',
//     element: isLogged ? <EventFeedbackProblemPage /> : <Navigate to="/login" replace />
// },
// {
//     path: '/mes-chantiers/event-feedback-problem/retour-produit',
//     element: isLogged ? <RetourProduitFormPage /> : <Navigate to="/login" replace />
// },
